module.exports = __webpack_public_path__ + "b8530a1f7d066b611efcc3af6a09712a.png";